import React from 'react'
import Posts from '../components/Posts'
import Footer from '../components/Footer'

const News = () => {
  return (
    <>
    <Posts/>
    <Footer/>
    </>
  )
}

export default News